import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    // 全局数据
    state: {
        loginData: {
            token: localStorage.getItem('token'),
            userid: localStorage.getItem('userid'),
            username: localStorage.getItem('username'),
            userheader: localStorage.getItem('userheader'),
            usercode: localStorage.getItem('userheader'),
            userarea: localStorage.getItem('userarea')
        },
        localData: {
            curdir: 0
        },
        pager: {
            total: 0,
            page: 1
        },
        nation: {
            code: 86
        },
        movement: {
            item: 0,
            pid: 0
        },
        active: 'index',
        language: '',
        table: {
            option: {}
        }
    },
    // 全局方法
    mutations: {
        xlogin: function(state, login) {
            state.loginData.token = login.token
            state.loginData.userid = login.userid
            state.loginData.username = login.username
            state.loginData.userheader = login.userheader
            state.loginData.usercode = login.usercode
            state.loginData.userarea = login.userarea
        },
        xlogout: function(state, logout) {
            state.loginData.token = null
            state.loginData.userid = null
            state.loginData.username = null
            state.loginData.userheader = null
            state.loginData.usercode = null
            state.loginData.userarea = null
            localStorage.removeItem('token')
            localStorage.removeItem('userid')
            localStorage.removeItem('username')
            localStorage.removeItem('userheader')
            localStorage.removeItem('usercode')
            localStorage.removeItem('userarea')
        },
        xfoldset: function(state, curdir) {
            state.localData.curdir = curdir
        },
        xpageset: function(state, total) {
            state.pager.total = total
        },
        xcodeset: function(state, code) {
            state.nation.code = code
        },
        xcpageset: function(state, code) {
            state.pager.page = code
        }
    },
    actions: {}
})



// WEBPACK FOOTER //
// ./src/store/store.js